module.exports = __webpack_public_path__ + "img/adaptations3.d7c49d04.png";